import { adminPath, basePath } from "../composables/useUrlRedirect";
import { UserAD, UserB2C } from "../service/userAuth/types";
import { defineStore } from "pinia";
import { ref } from "vue";
import { navigateToUrl } from "single-spa";

export const useAuthStore = defineStore(
  "auth",
  () => {
    const user = ref<UserB2C | null>(null);
    const userAD = ref<UserAD | null>(null);
    const secuency = ref<number | null>(null);
    const secuencyList = ref({
      SECUENCIA_08_DIVISAS: 1,
      SECUENCIA_00_INVERSIONES: 2,
      TODAS: 3,
    });
    const isAuthenticatedB2C = ref(false);
    const isAuthenticatedAD = ref(false);
    const token = ref<string | null>(null);

    /**
     * @description Establece el token de autenticación y su validez.
     * @param tkn Token de autenticación
     * @param isValid Indica si el token es válido
     */
    function setToken(tkn: string, isValid: boolean, isClient: boolean = true) {
      token.value = tkn;
      if (isClient) {
        isAuthenticatedB2C.value = isValid;
      } else {
        isAuthenticatedAD.value = isValid;
      }
    }

    /**
     * @description Establece la secuencia de autenticación.
     * @param secuency Secuencia de autenticación
     */
    function setSecuency(scy: string | number) {
      if (typeof scy === "string") {
        secuency.value = parseInt(scy, 10);
      } else {
        secuency.value = scy;
      }
    }

    /**
     * @description Establece el usuario autenticado.
     * @param user Usuario autenticado
     * @param isClient Indica si el usuario es un cliente
     */
    function setUser(usr: UserB2C | UserAD, isClient: boolean = true) {
      const isCltOrUsr = isClient;

      if (!isCltOrUsr) {
        userAD.value = usr as UserAD;
        return;
      }

      user.value = usr as UserB2C;
    }

    /**
     * @description Cierra la sesión local.
     * @param isClient Indica si el usuario es un cliente
     */
    function logoutLocal(isClient: boolean = true) {
      user.value = null;
      userAD.value = null;
      secuency.value = 0;
      isAuthenticatedB2C.value = false;
      isAuthenticatedAD.value = false;
      token.value = null;
      localStorage.removeItem("token");

      if (!isClient) {
        navigateToUrl(`${adminPath(window.location.hostname)}/auth/login`);
      } else {
        navigateToUrl(`${basePath(window.location.hostname)}/login`);
      }
    }

    return {
      user,
      userAD,
      secuency,
      secuencyList,
      isAuthenticatedB2C,
      isAuthenticatedAD,
      token,
      setToken,
      setSecuency,
      setUser,
      logoutLocal,
    };
  },
  {
    persist: true,
  }
);
